<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <div>
            <q-btn
              @click="showFilters();"
              :text-color="hideFilters ? 'grey-5' : 'white'"
              class="neutral-btn ctrl-button btn-compact"
              :class="{ primary: !hideFilters }"
              icon="filter_list"
              :icon-right="hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            />
          </div>
          <!-- Searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input
              color="grey-5"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="getString('module.tags.list.filter.label')"
            />
          </div>
        </div>
      </div>
      <!-- Invite button -->
      <div class="col-6" style="justify-content: flex-end">
        <q-btn v-if="$store.state.meStore.me.rights.includes('tag.add')"
          class="capitalize ctrl-button right"
          color="ctrl-turquoise"
          :label="getString('module.tags.add')"
          @click="$router.push('/tag/add')"
          icon-right="add"
        />
        <q-btn v-if="$store.state.meStore.me.rights.includes('tag.delete')"
          class="capitalize ctrl-button bg-ctrl-grey right q-mr-md"
          color="ctrl-turquoise"
          :disabled="!rowSelection.length"
          :label="$store.state.stringsStore.strings.list.actions.label"
          :class="{ 'button-active': rowSelection.length }">
            <q-icon size="large" name="mdi-chevron-down"/>
            <i v-show="rowSelection.length" class="counter">{{rowSelection.length}}</i>
            <!-- Direct child of target -->
            <q-popover anchor="bottom middle" self="top middle">
              <q-list link>
                <q-item
                  :class="{ 'disabled': !rowSelection.length }"
                  class="toolbar-list-item" @click.native="removeRows('tags')">
                  <q-icon color="positive" size="large" name="delete"/>
                  {{$store.state.stringsStore.strings.action.remove}}
                </q-item>
              </q-list>
            </q-popover>
        </q-btn>
      </div>
    </div>
    <!-- Filters block -->
    <transition name="fade">
    <div v-if="!hideFilters" class="table-block q-mb-md">
      <div class="row q-pa-md" style="justify-content: space-between;">
        <!-- Searchfield -->
        <div class="col-6 q-pa-md">
          <q-input color="primary"
            v-model="filters.label"
            @input="applyFilters"
          :float-label="getString('label')"/>
        </div>
        <!-- Searchfield -->
        <div class="col-6 q-pa-md">
          <q-input color="primary"
          v-model="filters.url"
          @input="applyFilters"
          :float-label="getString('url')"/>
        </div>
      </div>
      <div class="row q-pa-md" style="justify-content: space-between;">
        <div class="q-pa-md" style="vertical-align: middle;">
          <q-btn
            :disable="!activeFilters"
            @click="resetFilters()"
            class="capitalize ctrl-button"
            :color="activeFilters ? 'primary' : 'grey-4'"
            label="Reset"
          />
        </div>
      </div>
    </div>
    </transition>
    <table-overview
      :endpoint="endpoint"
      :responseFormat="'tags'"
      :columns="columns"
      :permission="permission"
      :module="module"
      :selectable="true">
    </table-overview>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
import TableOverview from '@/components/overview/TableOverview.vue';
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';
import common from '../common';

export default {
  mixins: [
    common,
    filtersMixin,
  ],
  components: {
    TableOverview,
  },
  data() {
    return {
      rowSelection: [],
      filters: {
        label: '',
        url: '',
      },
      searchTerm: '',
      selectable: true,
      isLoading: false,
      columns: [
        {
          name: '__slot:tags-label',
          title: getString('label'),
          sortField: 'label',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
        {
          name: '__slot:general-url',
          title: getString('url'),
          sortField: 'url',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
        {
          name: 'datetime',
          title: getString('datetime.label'),
          sortField: 'datetime',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m text-ellipsis',
          callback: 'tableFormatTime',
        },
      ],
      hideFilters: true,
      preferences: {
        page: 1,
        perPage: 10,
        sortField: null,
        sortOrder: null,
      },
    };
  },
  methods: {
    getString,

    removeRows(key) {
      EventBus.$emit('row-selection:delete', key);
    },
  },

  mounted() {
    EventBus.$on('row-selection:update', (payload) => {
      this.rowSelection = payload;
    });
  },
  destroyed() {
    EventBus.$off('row-selection:update');
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
</style>
